import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, Link } from "react-router-dom";
import ApiService, { initialAuthState } from "../../services/ApiService";
import { IoMdArrowRoundBack } from "react-icons/io";
import "./websiteOrders.css";

export default function WebsiteOrders() {
  const [orders, setOrders] = useState([]);
  const [filters, setFilters] = useState({
    status: "",
    statusGroup: "",
    search: "",
    fromDate: "",
    toDate: "",
  });

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const limit = 10;

  const navigate = useNavigate();

  const inProgressStatuses = [
  "confirmed",
  "packed",
  "shipped",
  "out_for_delivery",
];

const cancelledStatuses = [
  "cancelled",
  "partially_cancelled",
];

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    setLoading(true);

    try {
      const response = await ApiService.post("/order/getOrderList", {
        companyCode: initialAuthState.companyCode,
        unitCode: initialAuthState.unitCode,
      });

      if (response.status) {
        const sorted = [...response.data].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setOrders(sorted);
      }
    } catch (error) {
      console.error("Order fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredOrders = useMemo(() => {
    return orders.filter((order) => {
      const search = filters.search.toLowerCase();

      const matchStatus =
  filters.statusGroup === "in_progress"
    ? inProgressStatuses.includes(order.orderStatus)
    : filters.statusGroup === "cancelled"
      ? cancelledStatuses.includes(order.orderStatus)
      : !filters.status || order.orderStatus === filters.status;

      const matchSearch =
        !search ||
        order?.orderNumber?.toLowerCase().includes(search) ||
        order?.deliveryAddress?.name?.toLowerCase().includes(search) ||
        order?.deliveryAddress?.phoneNumber?.includes(search);

      const orderDate = new Date(order.createdAt);

      const matchFrom =
        !filters.fromDate || orderDate >= new Date(filters.fromDate);

      const matchTo =
        !filters.toDate ||
        orderDate <= new Date(`${filters.toDate}T23:59:59`);

      return matchStatus && matchSearch && matchFrom && matchTo;
    });
  }, [orders, filters]);

  const totalPages = Math.max(1, Math.ceil(filteredOrders.length / limit));

  const paginatedOrders = filteredOrders.slice(
    (page - 1) * limit,
    page * limit
  );

const stats = useMemo(() => {
  const inProgressStatuses = [
    "confirmed",
    "packed",
    "shipped",
    "out_for_delivery",
  ];

  return {
    total: orders.length,
    placed: orders.filter((o) => o.orderStatus === "placed").length,
    processing: orders.filter((o) =>
      inProgressStatuses.includes(o.orderStatus)
    ).length,
    delivered: orders.filter((o) => o.orderStatus === "delivered").length,
    cancelled: orders.filter((o) =>
      ["cancelled", "partially_cancelled"].includes(o.orderStatus)
    ).length,
  };
}, [orders]);

const filterByStatusCard = (status, statusGroup = "") => {
  setPage(1);
  setFilters((prev) => ({
    ...prev,
    status,
    statusGroup,
  }));
};

  const handleFilterChange = (e) => {
  setPage(1);
  setFilters({
    ...filters,
    [e.target.name]: e.target.value,
    statusGroup: "",
  });
};

  const clearFilters = () => {
  setPage(1);
  setFilters({
    status: "",
    statusGroup: "",
    search: "",
    fromDate: "",
    toDate: "",
  });
};

  const handleBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/all-orders");
  };

  const formatStatus = (status) => {
    return status ? status.replaceAll("_", " ") : "—";
  };

  return (
    <div className="website-orders-container">
      <div className="website-orders-shell">
        <div className="website-orders-topbar">
          <button onClick={handleBack} className="website-back-button">
            <IoMdArrowRoundBack /> Back
          </button>

          <Link to="/replace-requests" className="website-replace-request-button">
            Replace Requests
          </Link>
        </div>

        <section className="website-orders-hero">
          <div>
            {/* <p className="website-orders-eyebrow">Admin Dashboard</p> */}
            <h1>Customer Orders</h1>
            {/* <p>Track website orders, payments, delivery status and customer activity.</p> */}
          </div>

          <button className="website-refresh-button" onClick={fetchOrders}>
            Refresh Orders
          </button>
        </section>

        <div className="website-orders-stats">

 <button
  className={`website-stat-card ${filters.status === "" && filters.statusGroup === "" ? "active" : ""}`}
  onClick={() => filterByStatusCard("")}
>
  <span>Total Orders</span>
  <strong>{stats.total}</strong>
</button>

<button
  className={`website-stat-card ${filters.status === "placed" ? "active" : ""}`}
  onClick={() => filterByStatusCard("placed")}
>
  <span>Placed</span>
  <strong>{stats.placed}</strong>
</button>

<button
  className={`website-stat-card ${filters.statusGroup === "in_progress" ? "active" : ""}`}
  onClick={() => filterByStatusCard("", "in_progress")}
>
  <span>In Progress</span>
  <strong>{stats.processing}</strong>
</button>

<button
  className={`website-stat-card ${filters.status === "delivered" ? "active" : ""}`}
  onClick={() => filterByStatusCard("delivered")}
>
  <span>Delivered</span>
  <strong>{stats.delivered}</strong>
</button>

<button
  className={`website-stat-card ${filters.statusGroup === "cancelled" ? "active" : ""}`}
  onClick={() => filterByStatusCard("", "cancelled")}
>
  <span>Cancelled</span>
  <strong>{stats.cancelled}</strong>
</button>

</div>

        <div className="website-orders-filters">
          <div className="website-filter-group website-filter-search">
            <label>Search</label>
            <input
              type="text"
              name="search"
              placeholder="Order no, customer, phone"
              value={filters.search}
              onChange={handleFilterChange}
            />
          </div>

          <div className="website-filter-group">
            <label>Status</label>
            <select
  name="status"
  value={filters.status}
  onChange={handleFilterChange}
>
  <option value="">All Status</option>

  {/* <option value="pending">Pending</option> */}
  <option value="placed">Placed</option>
  <option value="confirmed">Confirmed</option>
  <option value="packed">Packed</option>
  <option value="shipped">Shipped</option>
  <option value="out_for_delivery">Out For Delivery</option>
  <option value="delivered">Delivered</option>
  <option value="cancelled">Cancelled</option>
  <option value="partially_returned">Partially Returned</option>
  <option value="returned">Returned</option>
  <option value="partially_cancelled">Partially Cancelled</option>
</select>
          </div>

          <div className="website-filter-group">
            <label>From</label>
            <input
              type="date"
              name="fromDate"
              value={filters.fromDate}
              onChange={handleFilterChange}
            />
          </div>

          <div className="website-filter-group">
            <label>To</label>
            <input
              type="date"
              name="toDate"
              value={filters.toDate}
              onChange={handleFilterChange}
            />
          </div>

          <button className="website-clear-button" onClick={clearFilters}>
            Clear
          </button>
        </div>

        <div className="website-orders-result-bar">
          <span>
            Showing <strong>{paginatedOrders.length}</strong> of{" "}
            <strong>{filteredOrders.length}</strong> orders
          </span>
        </div>

        <div className="website-orders-table-wrapper">
          <table className="website-orders-table">
            <thead>
              <tr>
                <th>Order No</th>
                <th>Customer</th>
                <th>Date</th>
                <th>Total</th>
                <th>Status</th>
                <th>Payment</th>
                <th>Items</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                [...Array(8)].map((_, index) => (
                  <tr key={index} className="skeleton-row">
                    {[...Array(8)].map((__, i) => (
                      <td key={i}>
                        <div className={i === 1 ? "skeleton skeleton-text" : "skeleton skeleton-small"} />
                      </td>
                    ))}
                  </tr>
                ))
              ) : paginatedOrders.length === 0 ? (
                <tr>
                  <td colSpan="8">
                    <div className="website-empty-state">
                      <h3>No Orders Found</h3>
                      <p>Try changing filters or clearing search values.</p>
                      <button onClick={clearFilters}>Clear Filters</button>
                    </div>
                  </td>
                </tr>
              ) : (
                paginatedOrders.map((order) => (
                  <tr key={order.id}>
                    <td>
                      <strong className="website-order-number">
                        {order.orderNumber}
                      </strong>
                    </td>

                    <td>
                      <div className="website-customer-cell">
                        <strong>{order?.deliveryAddress?.name || "—"}</strong>
                        <span>{order?.deliveryAddress?.phoneNumber || "No phone"}</span>
                      </div>
                    </td>

                    <td>{new Date(order.createdAt).toLocaleDateString()}</td>

                    <td>
                      <strong className="website-amount">
                        ₹{Number(order.totalAmount || 0).toFixed(2)}
                      </strong>
                    </td>

                    <td>
                      <span className={`status ${order.orderStatus}`}>
                        {formatStatus(order.orderStatus)}
                      </span>
                    </td>

                    <td>
                      <span className={`payment ${order.paymentStatus}`}>
                        {formatStatus(order.paymentStatus)}
                      </span>
                    </td>

                    <td>
                      <span className="website-items-pill">
                        {order.totalItems || 0}
                      </span>
                    </td>

                    <td>
                      <button
                        className="website-view-button"
                        onClick={() => navigate(`/order-details/${order.id}`)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="website-orders-pagination">
          <button disabled={page === 1} onClick={() => setPage(page - 1)}>
            Prev
          </button>

          <span>
            Page <strong>{page}</strong> / {totalPages}
          </span>

          <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
}









// import React, { useEffect, useState, useMemo } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import ApiService, { initialAuthState } from '../../services/ApiService';
// import OrderStatusPopup from './orderStatusPopup';
// import { IoMdArrowRoundBack } from "react-icons/io";
// import './websiteOrders.css';

// export default function WebsiteOrders() {
//   const [orders, setOrders] = useState([]);
//   const [filters, setFilters] = useState({
//     status: '',
//     search: '',
//     fromDate: '',
//     toDate: '',
//   });

  
//   const [loading, setLoading] = useState(false);

//   const [page, setPage] = useState(1);
//   const limit = 10;

//   const navigate = useNavigate();

//   console.log("abcd")

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const fetchOrders = async () => {
//     setLoading(true)

//     const response = await ApiService.post('/order/getOrderList', {
//       companyCode: initialAuthState.companyCode,
//       unitCode: initialAuthState.unitCode,
//     });

//     if (response.status) {
//       // 🔥 Sort: New arrivals first
//       const sorted = response.data.sort(
//         (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
//       );

//       setOrders(sorted);
//     }

//     setLoading(false)
//   };

//   // 🔍 FILTER LOGIC
//   const filteredOrders = useMemo(() => {
//     return orders.filter((order) => {
//       const matchStatus =
//         !filters.status || order.orderStatus === filters.status;

//       const matchSearch =
//         !filters.search ||
//         order.orderNumber.toLowerCase().includes(filters.search.toLowerCase()) ||
//         order?.deliveryAddress?.name
//           ?.toLowerCase()
//           .includes(filters.search.toLowerCase());

//       const orderDate = new Date(order.createdAt);

//       const matchFrom =
//         !filters.fromDate || orderDate >= new Date(filters.fromDate);

//       const matchTo =
//         !filters.toDate || orderDate <= new Date(filters.toDate);

//       return matchStatus && matchSearch && matchFrom && matchTo;
//     });
//   }, [orders, filters]);

//   // 📄 PAGINATION LOGIC
//   const totalPages = Math.ceil(filteredOrders.length / limit);

//   const paginatedOrders = filteredOrders.slice(
//     (page - 1) * limit,
//     page * limit
//   );

//   const handleFilterChange = (e) => {
//     setPage(1); // reset page
//     setFilters({ ...filters, [e.target.name]: e.target.value });
//   };

//   const handleBack = () => {
//     if (window.history.length > 1) {
//       navigate(-1);
//     } else {
//       navigate('/all-orders');
//     }
//   };

//   return (
//     <div className="website-orders-container">

//       <div className="replace-request-button-container">
//         <button onClick={handleBack} className="website-back-button">
//           <IoMdArrowRoundBack /> Back
//         </button>
//       </div>

//       <div className="replace-request-button-container">
//         <h2>Customer Orders</h2>
//         <Link to="/replace-requests" className="website-replace-request-button">
//           Replace Requests
//         </Link>
//       </div>

//       {/* 🔍 Filters */}
//       <div className="website-orders-filters">
//         <input
//           type="text"
//           name="search"
//           placeholder="Search Order ID / Name"
//           value={filters.search}
//           onChange={handleFilterChange}
//         />

//         <select name="status" value={filters.status} onChange={handleFilterChange}>
//           <option value="">All Status</option>
//           <option value="confirmed">Confirmed</option>
//           <option value="cancelled">Cancelled</option>
//           <option value="partially_cancelled">Partially Cancelled</option>
//         </select>

//         <input type="date" name="fromDate" onChange={handleFilterChange} />
//         <input type="date" name="toDate" onChange={handleFilterChange} />
//       </div>

//       {/* 📊 Table */}
//       <div className="website-orders-table-wrapper">
//         <table className="website-orders-table">
//           <thead>
//             <tr>
//               <th>Order No</th>
//               <th>Customer</th>
//               <th>Date</th>
//               <th>Total</th>
//               <th>Status</th>
//               <th>Payment</th>
//               <th>Items</th>
//               <th>Actions</th>
//             </tr>
//           </thead>

//           <tbody>
//             {loading ? (
//               [...Array(8)].map((_, index) => (
//                 <tr key={index} className="skeleton-row">
//                   <td><div className="skeleton skeleton-small"></div></td>
//                   <td><div className="skeleton skeleton-text"></div></td>
//                   <td><div className="skeleton skeleton-small"></div></td>
//                   <td><div className="skeleton skeleton-small"></div></td>
//                   <td><div className="skeleton skeleton-small"></div></td>
//                   <td><div className="skeleton skeleton-small"></div></td>
//                   <td><div className="skeleton skeleton-small"></div></td>
//                   <td><div className="skeleton skeleton-button"></div></td>
//                 </tr>
//               ))
//             ) : paginatedOrders.length === 0 ? (
//               <tr>
//                 <td colSpan="8">No Orders Found</td>
//               </tr>
//             ) : (
//               paginatedOrders.map((order) => (
//                 <tr key={order.id}>
//                   <td>{order.orderNumber}</td>
//                   <td>{order?.deliveryAddress?.name}</td>
//                   <td>{new Date(order.createdAt).toLocaleDateString()}</td>
//                   <td>₹{order.totalAmount}</td>
//                   <td>
//                     <span className={`status ${order.orderStatus}`}>
//                       {order.orderStatus}
//                     </span>
//                   </td>
//                   <td>{order.paymentStatus}</td>
//                   <td>{order.totalItems}</td>
//                   <td>
//                     <button onClick={() => navigate(`/order-details/${order.id}`)}>
//                       View
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* 📄 Pagination */}
//       <div className="website-orders-pagination">
//         <button disabled={page === 1} onClick={() => setPage(page - 1)}>
//           Prev
//         </button>

//         <span>Page {page} / {totalPages}</span>

//         <button
//           disabled={page === totalPages}
//           onClick={() => setPage(page + 1)}
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// }